import React from "react";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

export default function Pool(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_1"
            options={props.poolData}
            limitTags={5}
            value={props.poolData.filter((item) => props.poolIds.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} margin="normal" label={t("Pool")} variant="outlined" id="bl_table_TextField_0" />}
            onChange={(event, newValue) => {
                props.HandlePool(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
